<script>
  import { onDestroy } from "svelte";
  import { router } from "../stores/router.js";

  let currentRoute, params;

  const draw = (m, obj) => {
    params = obj || {};
    if (m.preload) {
      m.preload({ params }).then(() => {
        currentRoute = m.default;
      });
    } else {
      currentRoute = m.default;
    }
  };
  // window.addEventListener("focus", async () => {
  //     if (await sessionStatus()) {
  //         const qs = queryString.parse(location.search);
  //         window.location.assign(`${window.location.origin}${qs.next ? qs.next : ''}`);
  //     }
  // });

  // addEventListener("pushstate", obj => {
  //   router.route(obj.uri);
  // });
  $router
    .on("/", () => {
      import("./DefaultRoute.svelte").then(draw);
    })
    .on("/login", () => {
      import("./LoginRoute.svelte").then(draw);
    })
    .on("/activate", () => {
      import("./ActivateRoute.svelte").then(draw);
    })
    .on("/zendesk-activate", () => {
      import("./ActivateZendeskRoute.svelte").then(draw);
    })
    .on("/workspaces", () => {
      import("./WorkspacesRoute.svelte").then(draw);
    })
    .on("/zendesk-login", () => {
      import("./ZendeskLogin.svelte").then(draw);
    })
    .on("/*", (params) => {
      import("./SignupRoute.svelte").then((m) =>
        draw(m, { activationToken: params.wild })
      );
    });

  $router.listen();

  onDestroy($router.unlisten);
</script>

<div class="root">
  <svelte:component this={currentRoute} {params} />
</div>

<style>
  .root {
    display: flex;
    flex-direction: column;
    height: 100%;
  }
</style>
